import ExportButton from "components/Button/ExportButton/ExportButton";
import { Paper, RelatedPapersType } from "helpers/api";
import { MixpanelActionSource } from "helpers/services/mixpanel/events";
import useLabels from "hooks/useLabels";
import { useRelatedPapers } from "hooks/useRelatedPapers";
import RelatedPapersTab, { RelatedTab } from "./RelatedPapersTab";

type RelatedPapersProps = {
  id: string;
  handleClickSave: (paper: Paper) => void;
  relatedPaperType: RelatedPapersType;
};

function RelatedPapers({
  id,
  handleClickSave,
  relatedPaperType,
}: RelatedPapersProps) {
  const [relatedLabels] = useLabels("screens.details.related");
  const [exportPapersLabel] = useLabels(
    "screens.details.related.export-papers"
  );

  const {
    papers,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetchingNextPage,
    isLoading,
  } = useRelatedPapers({
    id,
    relatedPaperType,
  });

  const selectedTab =
    relatedPaperType === RelatedPapersType.CITATIONS
      ? RelatedTab.Citations
      : RelatedTab.References;

  const label =
    relatedPaperType === RelatedPapersType.CITATIONS
      ? relatedLabels["citations"]
      : relatedLabels["references"];

  const emptyMessage =
    relatedPaperType === RelatedPapersType.CITATIONS
      ? relatedLabels["no-citations-found"]
      : relatedLabels["no-references-found"];

  return (
    <div className="flex flex-col gap-8">
      <div>
        <div className="flex items-center justify-between border-b border-border-base pb-4 mb-1">
          <h3 className="text-body-base font-bold">{label}</h3>

          <ExportButton
            items={papers}
            title={label}
            skipPapersFetch={true}
            label={exportPapersLabel}
            actionSource={
              selectedTab === RelatedTab.Citations
                ? MixpanelActionSource.CitationList
                : MixpanelActionSource.ReferenceList
            }
          />
        </div>
        {isLoading || papers.length > 0 ? (
          <RelatedPapersTab
            selectedTab={selectedTab}
            onClickSave={handleClickSave}
            isLoading={isLoading || isFetchingNextPage}
            canLoadMore={hasNextPage}
            relatedPapers={papers}
            onClickLoadMore={fetchNextPage}
            isError={isError}
          />
        ) : (
          <div className="text-center text-fg-muted py-4">{emptyMessage}</div>
        )}
      </div>
    </div>
  );
}

export default RelatedPapers;
